/* eslint no-underscore-dangle: 0 */

import axios from 'axios';

import {
    API_URL,
    DEFAULT_TIMEOUT_IN_MS,
} from '../constants/API.constants';

import { setupLoginInterceptor } from './interceptors/login';

const createDefaultInterceptors = history => [
    setupLoginInterceptor(history),
];

const NetworkService = {
    _clients: new Map(),
    _enhancers: [],
    init(history, enhancers = null) {
        this._enhancers = enhancers || createDefaultInterceptors(history);
        this.getClient();
    },
    getClient(name = 'default', opts = {}) {
        if (this._clients.get(name)) return this._clients.get(name);

        const { enhancers = [], useDefaultEnhancers = true, ...axiosOptions } = opts;
        const defaultEnhancers = useDefaultEnhancers ? this._enhancers : [];
        const clientEnhancers = [...defaultEnhancers, ...enhancers];

        const client = axios.create({
            baseURL: API_URL,
            timeout: DEFAULT_TIMEOUT_IN_MS,
            ...axiosOptions,
        });

        clientEnhancers.forEach(interceptor => interceptor(client));

        this._clients.set(name, client);
        return client;
    },
    getClients() {
        return Array.from(this._clients.values());
    },
    getCancelTokenSource() {
        return axios.CancelToken.source();
    },
};

export default NetworkService;
